import styled from 'styled-components'

const FLOATING_SIDEBAR_BREAKPOINT = `1220px`

export const CompanyPageWrapperDIV = styled.div`
  --FloatingSidebarNav--width: calc(215px + var(--spacing--S));

  align-items: center;
  display: flex;
  flex-direction: column;

  @media (min-width: ${FLOATING_SIDEBAR_BREAKPOINT}) {
    align-items: flex-start;
    flex-direction: row;
    justify-content: flex-start;
    position: relative;
  }

  .FloatingSidebarNav {
    padding-top: var(--spacing--XL);
    max-width: var(--text-max-width);
    width: var(--container-width);

    @media (min-width: ${FLOATING_SIDEBAR_BREAKPOINT}) {
      display: block;
      flex: 0 0 var(--FloatingSidebarNav--width);
      position: sticky;
      top: 0;
      width: 100%;
      padding-left: var(--spacing--S);
    }
  }

  .content-wrapper {
    flex: 0 0 100%;

    @media (min-width: ${FLOATING_SIDEBAR_BREAKPOINT}) {
      margin-left: calc(var(--FloatingSidebarNav--width) * -1);
    }
  }
  
  .container {
    position: static;
  }
`

export const CompanyPageContentDIV = styled.div`
  margin: var(--spacing--XL) auto;
  max-width: var(--text-max-width);

  @media (min-width: ${FLOATING_SIDEBAR_BREAKPOINT}) {

  }

  strong,
    b, p b {
      color: var(--color--text-dark);
      font-weight: var(--font-weight--medium);
    }

  .Content {
    &,
    p {
      font-size: var(--font-size--S);
    }
  }
`
